var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "question-wrap",
      class: [
        { isLine: _vm.value.type === _vm.QTypes.LINE },
        { isRemark: _vm.value.type === _vm.QTypes.REMARK },
      ],
    },
    [
      _vm.value.ext && _vm.value.ext.edit
        ? _c(
            "div",
            {
              staticClass: "sort",
              staticStyle: {
                width: "100%",
                "text-align": "center",
                cursor: "move",
                position: "absolute",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  cursor: "move",
                  dragable: "false",
                  display: "inline-block",
                },
                attrs: {
                  width: "40",
                  src: "http://cnstatic01.e.vhall.com/static/images/signup-form/drop.png?v=o78iE3bYNdTd377uDRu6Jw%3D%3D",
                  alt: "",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "question-content",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.questionClick.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "index",
              class: [
                { isLine: _vm.value.type === _vm.QTypes.LINE },
                { isRemark: _vm.value.type === _vm.QTypes.REMARK },
              ],
            },
            [
              _vm.value.required === "Y"
                ? _c(
                    "span",
                    {
                      staticClass: "require-icon",
                      staticStyle: { color: "red" },
                    },
                    [_vm._v("*")]
                  )
                : _vm._e(),
              _vm._v("\n      " + _vm._s(_vm.getIndex) + ".\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "q-edit display" },
            [
              _vm.value.ext && _vm.value.ext.edit
                ? _c("div", { staticClass: "q-subject" }, [
                    _vm.value.type === _vm.QTypes.RADIO &&
                    _vm.value.style == "radio"
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("quest.k_2001")) +
                              "\n        "
                          ),
                        ])
                      : _vm.value.style === _vm.QTypes.MULTIPLE_SELECT
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2002")))])
                      : _vm.value.type === _vm.QTypes.CHECKBOX
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2003")))])
                      : _vm.value.type === _vm.QTypes.SELECT
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2004")))])
                      : _vm.value.type === _vm.QTypes.AREA
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2005")))])
                      : _vm.value.type === _vm.QTypes.REMARK
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2006")))])
                      : _vm.value.style === _vm.QTypes.COMPANY
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2007")))])
                      : _vm.value.style === _vm.QTypes.POSTION
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2008")))])
                      : _vm.value.style === _vm.QTypes.NAME
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2009")))])
                      : _vm.value.style === _vm.QTypes.SEX
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2010")))])
                      : _vm.value.style === _vm.QTypes.PHONE
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2011")))])
                      : _vm.value.style === _vm.QTypes.EMAIL
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2012")))])
                      : _vm.value.style === _vm.QTypes.BIRTHDAY
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2013")))])
                      : _vm.value.style === _vm.QTypes.INDUSTRY
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2014")))])
                      : _vm.value.style === _vm.QTypes.EDUCATION
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2015")))])
                      : _vm.value.type === _vm.QTypes.TEXT
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("quest.k_2016")))])
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "q-subject" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.value.title) },
                    }),
                  ]),
              _vm._v(" "),
              _vm.value.type === _vm.QTypes.LINE
                ? _c("div", { staticClass: "line" })
                : _vm._e(),
              _vm._v(" "),
              _vm.showInputCom
                ? _c("com-input", {
                    staticClass: "q-subject",
                    class: { error: _vm.value.error },
                    attrs: {
                      placeholder: _vm.$t("quest.k_2017"),
                      "max-length": 100,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                      change: _vm.changeTitle,
                      focus: _vm.focusTitle,
                    },
                    model: {
                      value: _vm.value.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "title", $$v)
                      },
                      expression: "value.title",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    ["phone", "privacy", "q-select-multiple"].includes(
                      _vm.value.ext.type
                    )
                      ? _vm.value.ext.type
                      : _vm.QComs[_vm.value.type],
                    {
                      ref: "content",
                      tag: "component",
                      attrs: {
                        isPreview: _vm.isPreview,
                        isReplay: _vm.isReplay,
                      },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    }
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.value.ext && _vm.value.ext.edit
            ? _c(
                "div",
                {
                  staticClass: "q-operate",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "q-operate-left" }, [
                    _vm.value.type === _vm.QTypes.MATRIX
                      ? _c(
                          "a",
                          {
                            staticClass: "add-row-item",
                            on: { click: _vm.addRowItem },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("quest.k_2018")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.value.type === _vm.QTypes.MATRIX
                      ? _c(
                          "a",
                          {
                            staticClass: "add-column-item",
                            on: { click: _vm.addColumnItem },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("quest.k_2019")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAddItem || _vm.value.type === _vm.QTypes.SELECT
                      ? _c(
                          "a",
                          {
                            staticClass: "add-select-item",
                            class: {
                              disabledAdd: _vm.value.detail.list.length >= 30,
                            },
                            on: { click: _vm.addItem },
                          },
                          [
                            _c("i", { staticClass: "vh-icon-plus" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("quest.k_2020")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAddItem &&
                    _vm.value.style != _vm.QTypes.MULTIPLE_SELECT
                      ? _c("span", { staticClass: "line add-other-item" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAddItem &&
                    _vm.value.style != _vm.QTypes.MULTIPLE_SELECT
                      ? _c(
                          "a",
                          {
                            staticClass: "add-select-item add-other-item",
                            class: {
                              disabledAdd:
                                _vm.value.detail.list.length >= 30 ||
                                _vm.value.detail.list.some(function (i) {
                                  return i.custom_opt == 1
                                }),
                            },
                            on: { click: _vm.addOtherItem },
                          },
                          [
                            _c("i", { staticClass: "vh-icon-plus" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("quest.k_2021")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAddItem || _vm.value.type === _vm.QTypes.SELECT
                      ? _c("span", { staticClass: "addTip" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("quest.k_2022")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "q-operate-right" },
                    [
                      (_vm.value.type == _vm.QTypes.CHECKBOX ||
                        _vm.value.style == _vm.QTypes.MULTIPLE_SELECT) &&
                      _vm.verifiy
                        ? _c(
                            "div",
                            { staticClass: "min-max-select" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("quest.k_2023")) +
                                  "\n          "
                              ),
                              _c(
                                "vh-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("quest.k_2024"),
                                    size: "mini",
                                  },
                                  model: {
                                    value: _vm.value.detail.min,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.value.detail, "min", $$v)
                                    },
                                    expression: "value.detail.min",
                                  },
                                },
                                [
                                  _c("vh-option", {
                                    attrs: {
                                      label: _vm.$t("quest.k_2025"),
                                      value: -1,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.value.detail.list,
                                    function (item, index) {
                                      return _c("vh-option", {
                                        key: index,
                                        attrs: {
                                          disabled:
                                            _vm.value.detail.max > 0 &&
                                            index + 1 > _vm.value.detail.max,
                                          label:
                                            index + 1 + _vm.$t("quest.k_2026"),
                                          value: index + 1,
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v("\n            最多\n          "),
                              _c(
                                "vh-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("quest.k_2028"),
                                    size: "mini",
                                  },
                                  model: {
                                    value: _vm.value.detail.max,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.value.detail, "max", $$v)
                                    },
                                    expression: "value.detail.max",
                                  },
                                },
                                [
                                  _c("vh-option", {
                                    attrs: {
                                      label: _vm.$t("quest.k_2025"),
                                      value: -1,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.value.detail.list,
                                    function (item, index) {
                                      return _c("vh-option", {
                                        key: index,
                                        attrs: {
                                          disabled:
                                            _vm.value.detail.min > 0 &&
                                            index + 1 < _vm.value.detail.min,
                                          label:
                                            index + 1 + _vm.$t("quest.k_2026"),
                                          value: index + 1,
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "del",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.remove.apply(null, arguments)
                            },
                          },
                        },
                        [_c("i", { staticClass: "iconfont-v3 saasicon-trash" })]
                      ),
                      _vm._v(" "),
                      _vm.showRequire && _vm.value.ext && _vm.value.ext.edit
                        ? _c("span", { staticClass: "required-des" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("quest.k_2029")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRequire && _vm.value.ext && _vm.value.ext.edit
                        ? _c("vh-switch", {
                            key: _vm.index,
                            staticClass: "switch",
                            attrs: {
                              "active-color": "#FB3A32",
                              "inactive-color": "#CECECE",
                              size: "mini",
                              width: 32,
                            },
                            model: {
                              value: _vm.verifiy,
                              callback: function ($$v) {
                                _vm.verifiy = $$v
                              },
                              expression: "verifiy",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }